import React from "react";
import { DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { rangePickerDisabledDate } from "../../../redux/constants";
import durationIcon from "../../../assets/calendarIconLB.svg";
import durationWhiteIcon from "../../../assets/WhiteIcons/calendarWhiteIconLB.svg";
import { setSingleDate } from "../../../redux/actions/DateTime";
import moment from "moment";
import { getTrendsData } from "../../../redux/actions/ApiCall";

const SingleDate = ({ datePicker, type, split, setDatepicker, disabled }) => {
  const dispatch = useDispatch();
  const singleDate = useSelector((state) => state.DateTime.singleDate);
  const trendsData = useSelector((state) => state.WidgetAPI.trendsData);
  const authParams = useSelector((state) => state.Authentication.authParams);

  let dateFormat = "DD MMM YYYY";
  const onSingleChange = (date, dateString) => {
    let updateObj = { ...singleDate };
    updateObj.AgentActivity = moment(dateString).format("YYYY/MM/DD");
    dispatch(setSingleDate(updateObj));
    let selectedDate = moment(date)?.format("YYYY/MM/DD HH:mm");
    let today = moment()?.format("YYYY/MM/DD HH:mm");
    if (type === "trends") {
      let updatedPayloadData = { ...trendsData?.payloadObj };
      if (
        moment(moment(date)?.format("YYYY/MM/DD"))?.isSame(
          moment(today)?.format("YYYY/MM/DD")
        )
      ) {
        // for same
        updatedPayloadData.body.start_date = selectedDate;
        updatedPayloadData.body.end_date = today;
      } else {
        // for another day
        updatedPayloadData.body.start_date = updateObj.AgentActivity + " 00:00";
        updatedPayloadData.body.end_date = updateObj.AgentActivity + " 23:59";
      }
      updatedPayloadData && dispatch(getTrendsData(updatedPayloadData));
    }
  };

  return (
    <div
      className={`from-group floating-label-group d-flex ${
        disabled ? "disable" : ""
      }`}
    >
      <DatePicker
        style={{ minWidth: "18rem" }}
        dropdownClassName={`createDateRangePicker ${
          authParams?.theme_type === "1" ? "darkTheme" : ""
        }`}
        onChange={onSingleChange}
        placeholder={null}
        format={dateFormat}
        value={moment(singleDate?.AgentActivity)}
        disabledDate={(current) =>
          rangePickerDisabledDate(current, "01 Dec 2015", new Date())
        }
        className="text_regular p-0 border-color border-radius-4"
        suffixIcon={
          <img
            src={
              authParams?.theme_type === "1" ? durationWhiteIcon : durationIcon
            }
            className="durationIcon"
            alt="duration Icon"
          />
        }
        size={"small"}
        allowClear={false}
        //disabled={disabled}
      />
      <label
        htmlFor="Duration"
        className={`portlet-label floating-label font-size12 font-weight400`}
        style={{
          top: "-0.8rem",
          backgroundColor: disabled ? "transparent" : "#fff",
        }}
      >
        Select Date
        <span class="error">*</span>
      </label>
    </div>
  );
};

export default SingleDate;
